import * as z from "zod";

import { AddressTypeEnum } from "./address";
import { CompanyFreightSchema } from "./freight";

// Payment Terms Enum
export const PaymentTermsEnum = z.enum([
  "cash_on_delivery",
  "net_14_days",
  "net_30_eom",
]);

export const CompanyAddressSchema = z.object({
  id: z.string().uuid(),
  address_id: z.string().uuid(),
  company_id: z.string().uuid(),
  address_type: AddressTypeEnum.default("additional"),
  label: z.string().max(50, "Label must be less than 50 characters").optional(),
  created: z
    .date()
    .optional()
    .default(() => new Date()),
  updated: z
    .date()
    .optional()
    .default(() => new Date()),
});

export const CompanyBrandSchema = z.object({
  id: z.string().uuid(),
  brand_id: z.string().uuid(),
  company_id: z.string().uuid(),
  end_date: z.date().optional(),
  created: z
    .date()
    .optional()
    .default(() => new Date()),
  updated: z
    .date()
    .optional()
    .default(() => new Date()),
});

export const CompanyEmployeeSchema = z.object({
  id: z.string().uuid(),
  user_id: z.string().uuid(),
  job_id: z.string().uuid(),
  end_date: z.date().optional(),
  created: z
    .date()
    .optional()
    .default(() => new Date()),
  updated: z
    .date()
    .optional()
    .default(() => new Date()),
});

export const CompanyPricingTierSchema = z.object({
  id: z.string().uuid(),
  company_id: z.string().uuid(),
  tier_id: z.string().uuid(),
  end_date: z.date().optional(),
  created: z
    .date()
    .optional()
    .default(() => new Date()),
  updated: z
    .date()
    .optional()
    .default(() => new Date()),
});

export const CompanyRepresentativeSchema = z.object({
  id: z.string().uuid(),
  company_id: z.string().uuid(),
  user_id: z.string().uuid(),
  end_date: z.date().optional(),
  created: z
    .date()
    .optional()
    .default(() => new Date()),
  updated: z
    .date()
    .optional()
    .default(() => new Date()),
});

export const CompanySchema = z.object({
  id: z.string().uuid(),
  name: z.string().min(1, "Company name is required"),
  cell: z
    .string()
    .max(20, "Cell number must be less than 20 characters")
    .nullable(),
  email: z.string().email("Invalid email address").max(255).nullable(),
  website: z.string().url("Invalid website URL").max(255).nullable(),
  business_number: z
    .string()
    .max(20, "Business number must be less than 20 characters")
    .nullable(),
  company_prefix: z
    .string()
    .max(10, "Company prefix must be less than 10 characters")
    .transform((val) => val?.toUpperCase())
    .nullable(),
  logo: z.string().nullable(),
  payment_terms: PaymentTermsEnum.default("cash_on_delivery"),
  drop_off: z.boolean().default(false),
  address_ids: z.array(z.string().uuid()),
  pricing_tier_id: z.string().uuid().nullable(),
  brand_ids: z.array(z.string().uuid()),
  representative_ids: z.array(z.string().uuid()),
  created: z
    .date()
    .nullable()
    .default(() => new Date()),
  updated: z
    .date()
    .nullable()
    .default(() => new Date()),
});

// Create an extended schema for operations that include freight accounts
export const CompanyWithFreightSchema = CompanySchema.extend({
  freight_accounts: z.array(CompanyFreightSchema).optional(),
});

export const createCompanySchema = CompanyWithFreightSchema.omit({
  id: true,
  created: true,
  updated: true,
});

export const updateCompanySchema = CompanyWithFreightSchema.partial().omit({
  id: true,
  created: true,
  updated: true,
});
